import { render, staticRenderFns } from "./classfiySearch.vue?vue&type=template&id=32368f78&scoped=true"
import script from "./classfiySearch.vue?vue&type=script&lang=js"
export * from "./classfiySearch.vue?vue&type=script&lang=js"
import style0 from "./classfiySearch.vue?vue&type=style&index=0&id=32368f78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32368f78",
  null
  
)

export default component.exports